import { getEl } from './dom.js';

import recommendations from 'bundle-text:./data/recs.json';
export const RECOMMENDATIONS = JSON.parse(recommendations);
import Mustache from 'mustache';

let recommendationTemplate;

export function setupRecommendations() {
  recommendationTemplate = getEl('recommendationTemplate').innerHTML;
  Mustache.parse(recommendationTemplate);
}


export function showRecommendation(key) {
  if (key !== undefined && RECOMMENDATIONS.recommendations[key] !== undefined) {
    getEl('rec').innerHTML =
      Mustache.render(recommendationTemplate, RECOMMENDATIONS.recommendations[key]);
    getEl('rec').className = 'fadeIn';
  }
}